import store from './store'
import { authenticationService } from './authenticationService'

export * from './store/types'

/**
 * Module façade for authentication, in AuthorBase's namespaced-bag shape.
 */
export function useAuth () {
  return {
    auth: {
      store,
      service: authenticationService()
    }
  }
}
